import React from "react";

export function EventContentSkeleton() {
	return (
		<div className="event__offer">
			<div className="loader--skeleton loader--skeleton__item--sportmenu-live card u-padd--huge u-mar--bottom--xsml" />
			<div className="loader--skeleton loader--skeleton__item--sportmenu-live card u-padd--huge u-mar--bottom--xsml" />
			<div className="loader--skeleton loader--skeleton__item--sportmenu-live card u-padd--huge" />
		</div>
	);
}
